import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ApiPostResponse } from "@AxiosWrapper";

/**
 * Redux state for signinData. Populated via `setSigninData({ data })` with the whole
 * `/accounts/getSigninData` response body (see Router.tsx); `null` until the first dispatch. Consumers
 * read `signinData.data.frontendUrl` and `signinData.data.EnableMultiPortal`, both on that route's
 * success arm.
 */
export type SigninDataState = { data?: ApiPostResponse<"/accounts/getSigninData"> } | null;

const initialState = null as SigninDataState;

const signinDataSlice = createSlice({
  name: "signinData",
  initialState,
  reducers: {
    setSigninData: (_state: SigninDataState, action: PayloadAction<SigninDataState>) => action.payload,
  },
});

export const { setSigninData } = signinDataSlice.actions;
export default signinDataSlice.reducer;
